module.exports = __webpack_public_path__ + "img/Jll.c52a90e3.svg";